import { FC } from 'react';
import { Grid, Stack, Step, StepLabel, Stepper } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type Props = Readonly<{
	step: 'basics' | 'setup' | 'location';
	skipSetup: boolean;
}>;

const CreateMetricStepper: FC<Props> = ({ step, skipSetup }) => {
	return (
		<Grid item width={'100%'} marginBottom={2}>
			<Stack alignItems={'center'}>
				<Stack width={300}>
					<Stepper nonLinear={true}>
						<Step active={step === 'basics'} completed={step === 'setup' || step === 'location'}>
							<StepLabel>
								<FormattedMessage id={'form.metric.create.basics.label'} />
							</StepLabel>
						</Step>
						{!skipSetup && (
							<Step active={step === 'setup'} completed={step === 'location'}>
								<StepLabel>
									<FormattedMessage id={'form.metric.create.setup.label'} />
								</StepLabel>
							</Step>
						)}
						<Step active={step === 'location'}>
							<StepLabel>
								<FormattedMessage id={'form.metric.create.location.label'} />
							</StepLabel>
						</Step>
					</Stepper>
				</Stack>
			</Stack>
		</Grid>
	);
};

export { CreateMetricStepper };
